import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import NewReferenceSearch from './new-reference-search/NewReferenceSearch';
import { IParts } from 'interfaces/price';
import { notify } from 'utils/marketplace';
import TariffTable from 'applications/automotor/views/espace-automotor-offer/TariffTable/TariffTable';
import Spinner from 'components/spinner/Spinner';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import './AddReferenceModalWithPrice.scss';
import DefaultTable from 'components/tables/DefaultTable/DefaultTable';
import { Column } from 'react-table';
import CURRENCY from 'utils/constants/currency';

type Props = {
  setNewRefData: (data: IParts) => void
  setOpenModal: (openModal: boolean) => void
  tableData?
  importReference?: boolean
  proformaFile?: boolean
  referenceData?: boolean,
  notSetLocalStorage?: boolean
}

const c = 'add-reference-modal-with-price';

const AddReferenceModalWithPrice: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem('userData')!);

  const [data, setData] = useState<IParts[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState<IParts>();

  useEffect(() => {
    if (selectedItem) {
      setLoading(true);

      setData([selectedItem]);
      setLoading(false);
    }
  }, [selectedItem]);

  function handleClick() {
    if (selectedItem) {
      props.setNewRefData(selectedItem);
      props.setOpenModal(false);
      notify(t('_success'), 'success');
    }

  }

  const columnsOrderItems = useMemo(
    (): Column<IParts>[] => [

      {
        Header: `${t('_reference')}`,
        accessor: 'reference',
      },
      {
        Header: `${t('_mark')}`,
        accessor: 'name',
      },
      {
        Header: `${t('_description')}`,
        accessor: 'description',


      },
      {
        Header: `${t('_price')}`,
        accessor: 'price',
        Cell: (row) => <span>{CURRENCY[user!.currency]}{row.value}</span>

      }

    ],
    [],
  );

  return (
    <div className={c}>
      <div className={`${c}__header`}>
        <div className={`${c}__header-title`}>{t('_add_reference')}</div>
        <div className={`${c}__header-close`}><FontAwesomeIcon icon={faClose} onClick={() => props.setOpenModal(false)} /></div>
      </div>
      <div className={`${c}__content`}>
        <div className={`${c}__content-search`}>
          <NewReferenceSearch setSelectedItem={setSelectedItem} />
        </div>
        <div className={`${c}__content-table ${loading ? 'is-loading' : ''}`}>
          {loading ? <Spinner class="extra-small" /> : (
            !!data.length &&
            <DefaultTable columns={columnsOrderItems} data={data} loading={loading} noFooter />

          )}
        </div>
      </div>
      {!!data.length && (
        <div className={`${c}__footer`}>
          <div className={`${c}__footer-btn yes`}>
            <DefaultButton text={t('_add')} onClick={handleClick} blue />
          </div>
          <div className={`${c}__footer-btn no`}>
            <DefaultButton text={t('_cancel')} onClick={() => props.setOpenModal(false)} red />
          </div>
        </div>
      )}
    </div>
  );
};

export default AddReferenceModalWithPrice;